import { render, staticRenderFns } from "./kaibo.vue?vue&type=template&id=21effbca&scoped=true"
import script from "./kaibo.vue?vue&type=script&lang=js"
export * from "./kaibo.vue?vue&type=script&lang=js"
import style0 from "./kaibo.vue?vue&type=style&index=0&id=21effbca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21effbca",
  null
  
)

export default component.exports